"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreditDiscountsData = void 0;
var getCreditDiscountsData = function (carConfigurations) {
    var result = [];
    var configurations = carConfigurations[0].configurations;
    var _a = configurations[0], credit_discount = _a.credit_discount, trade_in_discount = _a.trade_in_discount, recycling_discount = _a.recycling_discount;
    result.push({
        title: 'Покупка в кредит',
        discount: credit_discount,
    }, {
        title: 'Скидка за Trade-in',
        discount: trade_in_discount,
    }, {
        title: 'Утилизация вашего авто',
        discount: recycling_discount,
    });
    return result;
};
exports.getCreditDiscountsData = getCreditDiscountsData;
